<template>
  <div ref="rootEl" style="flex-grow: 1; position: relative">
    <div
      :style="{
        height: height + 'px',
        width: innerWidth + 'px',
        overflowY: 'auto',
        position: 'absolute',
        paddingRight: '1rem',
      }"
      class="custom-scrollbar"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useElementSize } from "@vueuse/core";
import { computed, ref } from "vue";

const props = defineProps({
  rightGap: {
    type: Boolean,
    default: true,
  },
});

const rootEl = ref();

const { height, width } = useElementSize(
  rootEl,
  { height: 0, width: 0 },
  {
    box: "border-box",
  }
);

const innerWidth = computed(() => Math.max(0, width.value - (props.rightGap ? 16 : 0)));
</script>
